import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_FAMILIES = "/api/families"

export async function getFamilies(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FAMILIES
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getFamily(id) {
  let url = REACT_APP_API_URL + ENDPOINT_FAMILIES + "/" + id
  return await getObject(url)
}

export async function putFamily(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FAMILIES + "/" + id
  return await putObject(url, putValues)
}

export async function patchFamily(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FAMILIES + "/" + id
  return await patchObject(url, patchValues)
}

export async function postFamily(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FAMILIES
  return await postObject(url, postValues)
}
